import { render, staticRenderFns } from "./AnnouncementCreate.vue?vue&type=template&id=df0e4448"
import script from "./AnnouncementCreate.vue?vue&type=script&lang=js"
export * from "./AnnouncementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports